import { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import { inject } from 'mobx-react';
import PrimaryButton from './buttons/PrimaryButtonComponent';
import ColumnSelectMobileComponent from '../tool/step3/ColumnSelectMobileComponent';

class ChooseProductMobileComponent extends Component {
  render() {
    const {
      labelInterests,
      sortedFixedRateTerm,
      getFixedRateTermIndex,
    } = this.props;

    const sortedColumnIndex = getFixedRateTermIndex(sortedFixedRateTerm);

    const rows = labelInterests.map((label) => {
      const initialInterest = label.interests[sortedColumnIndex].initialInterest ?
        numeral(label.interests[sortedColumnIndex].initialInterest / 100).format('%0.00') : '-';
      const averageInterest = label.interests[sortedColumnIndex].averageInterest ?
        numeral(label.interests[sortedColumnIndex].averageInterest / 100).format('%0.00') : '-';

      let providerName = '';
      // eslint-disable-next-line react/prop-types
      const provider = this.props.ProviderLabelData.labels.find(providerLabel => providerLabel.id === label.id)

      if (!_.isEmpty(provider)) {
        providerName = provider.providerName;
      }

      return (
        <div key={label.id} className="choose-product-table-mobile__row">
          <div className="choose-product-table-mobile__logo">
            {<img src={label.logo} alt="logo" />}
          </div>
          <div className={'choose-product-table-mobile__label'}>
            <div className="choose-product-table-mobile__label__label-name">{providerName}</div>
            <div className="choose-product-table-mobile__label__product">{label.product}</div>
          </div>
          <div className="choose-product-table-mobile__interest">
            <div className="choose-product-table-mobile__interest__label">
              Aanvangsrente {this.props.sortedFixedRateTerm} jaar:
            </div>
            <div className="choose-product-table-mobile__interest__interest">
              {initialInterest}
            </div>
            <div className="choose-product-table-mobile__interest__label">
              Looptijdrente {this.props.sortedFixedRateTerm} jaar:
            </div>
            <div className="choose-product-table-mobile__interest__interest">
              {averageInterest}
            </div>
            <div className="choose-product-table-mobile__interest__label">
              Looptijdrente mogelijk:
            </div>
            <div className="choose-product-table-mobile__interest__interest">
              {(label.hasAutoRiskClassReduction &&
                <img src="/images/looptijdrente-icoon.png" alt="Ja" className="icon" />) || 'Nee'}
            </div>
          </div>
          <div className="choose-product-table-mobile__calculate">
            <PrimaryButton
              text="Bereken uw voordeel"
              onClickHandler={() => {
                this.props.calculateBenefit(label.id, initialInterest, this.props.sortedFixedRateTerm);
              }}
              show
            />
          </div>
        </div>
      );
    });

    return (
      <div className={'choose-product-table-mobile'}>
        {this.props.children}
        <div >
          {rows}
        </div>
      </div>
    );
  }
}

ChooseProductMobileComponent.propTypes = {
  sortedFixedRateTerm: PropTypes.number,
  getFixedRateTermIndex: PropTypes.func,
  children: PropTypes.node,
  ProviderLabelData: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  calculateBenefit: PropTypes.func,
  labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
};

ChooseProductMobileComponent.defaultProps = {
  sortedFixedRateTerm: 20,
  getFixedRateTermIndex: () => {},
  children: null,
  ProviderLabelData: {
    labels: {},
  },
  calculateBenefit: () => {},
  labelInterests: [],
};

export default inject('ProviderLabelData')(ChooseProductMobileComponent);
